import React, { memo, useState } from 'react'
import './index.less'
import { Button, Drawer, Form, message } from 'antd'
import ExperPorts from '../ExperPorts'
import Flex from '../Flex'


type ExperAddToolsProps = {
    open: boolean
    onClose: () => void
    ports: any[]
    onSave?: (data: any) => Promise<any> // 保存接口  保存成功会关闭窗口
}


const ExperAddTools: React.FC<ExperAddToolsProps> = (props) => {

    const {
        open,
        onClose,
        ports,
        onSave
    } = props

    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)                                     // 保存loading

    const save = async () => {
        const data = await form.validateFields().catch(() => { })
        if (data == undefined) return
        data.port = Number(data?.port)
        if (ports?.some((item: any) => item?.port === data.port)) {
            message.destroy()
            message.warning('端口重复')
            return
        }
        setLoading(true)
        await onSave?.(data)
        setLoading(false)
        message.destroy()
        message.success('保存成功')
        onClose()
    }


    return (
        <Drawer
            placement='right'
            closable={false}
            destroyOnClose
            onClose={onClose}
            open={open}
            width={712}
            maskClosable={false}
            rootClassName='ExperAddTools'
        >
            <Flex justify='space-between' align='center' style={{ height: '48px', borderBottom: '1px solid #E5E5E5', padding: '0 30px' }}>
                <span>

                </span>
                <span style={{ color: '#333333', fontSize: '16px', fontWeight: 'bold' }}>添加端口</span>
                <span>

                </span>
            </Flex>

            <div className='ExperAddTools-content'>
                <Form
                    form={form}
                    colon={false}
                    autoComplete="off"
                    style={{ height: '100%' }}
                >
                    <ExperPorts />
                </Form>
            </div>

            <Flex gap={20} justify='center' align='center' style={{ height: '72px' }}>
                <Button onClick={onClose}>取消</Button>
                <Button loading={loading} type='primary' onClick={save}>保存</Button>
            </Flex>
        </Drawer>
    )
}

export default memo(ExperAddTools)